import { type ReactNode } from 'react'
import Link from 'next/link'
import { paths } from '@mc/paths'
import { TrackClick } from 'pages/certificates/tracking'

// Shared with mccerts-2624_v1_hub_subs_row — keep until BOTH experiments
// conclude.
// Tracked "Learn More" link to the subscription LP. Trans injects the
// translated text as children, so the TrackClick wrapper must live inside a
// component rather than in a Trans components map directly.
export const LearnMoreLink = ({ children }: { children?: ReactNode }) => (
  <TrackClick event='certificateLandingClick' action='learn-more'>
    <Link
      href={paths.certificatesAnnualPass}
      className='whitespace-nowrap underline text-c-text-tint-3'
    >
      {children}
    </Link>
  </TrackClick>
)
